import Vue from 'vue';

export default Vue.directive('app-regex-filter', {
  bind: (el, binding) => {
    const { value: regex } = binding;

    el.addEventListener('input', (event) => {
      const { value } = event.target;
      event.target.value = value.replace(regex, '');
    });
  },
});
